import img1 from "../../image/Actillin Syrup.webp";
import img2 from "../../image/Cortigem Hexa Injection.webp";
import img3 from "../../image/Zithlogic-250 Tablets.webp";
import img4 from "../../image/Neviligan-25 Tablets.webp";
import img5 from "../../image/Utimend Chewable Tablets.webp";
import img6 from "../../image/Mefgesic Plus Suspension.webp";
import img7 from "../../image/Nervidiaz Tablets.webp";
import img8 from "../../image/Lycofree Softgel Capsules.webp";
import img9 from "../../image/Health-CB Multivitamin & Multimineral Tablets.webp";
import img10 from "../../image/Lecain-LA Gel.webp";
import img11 from "../../image/Ferbion Sachets.webp";
import img12 from "../../image/Ferbion Plus Sachets.webp";
import img13 from "../../image/Viscotren 400 Tablets.png";

const products = [
  {
    name: "Actillin Syrup",
    img: img1,
  },
  {
    name: "Cortigem Hexa Injection",
    img: img2,
  },
  {
    name: "Zithlogic-250 Tablets",
    img: img3,
  },
  {
    name: "Neviligan-25 Tablets",
    img: img4,
  },
  {
    name: "Utimend Chewable Tablets",
    img: img5,
  },
  {
    name: "Mefgesic Plus Suspension",
    img: img6,
  },
  {
    name: "Nervidiaz Tablets",
    img: img7,
  },
  {
    name: "Lycofree Softgel Capsules",
    img: img8,
  },
  {
    name: "Health-CB Multivitamin & Multimineral Tablets",
    img: img9,
  },
  {
    name: "Lecain-LA Gel",
    img: img10,
  },
  {
    name: "Ferbion Sachets",
    img: img11,
  },
  {
    name: "Ferbion Plus Sachets",
    img: img12,
  },
  {
    name: "Viscotren 400 Tablets",
    img: img13,
  },
];

export default products;